const CDN = 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/tap_game';
const set = (folder) => Array.from({ length: 8 }, (_, i) => `${CDN}/${folder}/${i}.webp`);

const RAW = [
    { id: 'lia',   name: 'Lia',   teaser: 'The girl next door',     folder: '1st', durationMs: 50000 },
    { id: 'mia',   name: 'Mia',   teaser: 'Loves the attention',    folder: '2nd', durationMs: 60000 },
    { id: 'sofia', name: 'Sofia', teaser: 'Bad influence',          folder: '3rd', durationMs: 70000 },
    { id: 'kira',  name: 'Kira',  teaser: 'Knows what she wants',   folder: '4th', durationMs: 85000 },
    { id: 'eva',   name: 'Eva',   teaser: 'The final boss',         folder: '5th', durationMs: 100000 },
];

export const GAME_GIRLS = RAW.map(g => ({
    ...g,
    cover: `${CDN}/${g.folder}/0.webp`,
    finale: `${CDN}/${g.folder}/7.webp`,
    photos: set(g.folder),
}));

export const UNLOCKED_KEY = 'mn_games_unlocked';
